import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import Main from './main/Main';
import Login from './login/Login';
import 'react-infinite-calendar/styles.css';

class App extends Component {
  render() {
    const { history } = this.props;
    return (
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/login" component={Login}/>
          <Route path="/" component={Main}/>
        </Switch>
      </ConnectedRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js